<div
  id="app-sidebar-10"
  class="w-[245px] h-screen block shrink-0 bg-surface-950 text-surface-100 text-[13px] p-[22px_14px] overflow-auto">
  <div class="flex flex-col h-full">
    <div class="px-[10px] pb-[22px] flex items-center gap-3 text-surface-50">
      <img src="favicon.ico" class="w-6 h-6" />
      <div class="flex flex-col">
        <span class="text-[16px] font-extrabold leading-tight whitespace-nowrap">Auth Server</span>
        <small class="block text-surface-300 text-[8px] tracking-[0.2em] mt-1 whitespace-nowrap">CONTROL PLANE</small>
      </div>
    </div>
    <div class="mx-[6px] rounded-lg bg-surface-900 p-[10px] text-surface-100 whitespace-nowrap">
      <span class="mr-[7px] inline-block h-[7px] w-[7px] rounded-full bg-green-400 align-middle"></span>
      Production
    </div>
    <div class="overflow-y-auto flex-1 flex flex-col gap-4">
      <ul class="list-none m-0 flex flex-col">
        <li>

          @for (group of sidebarData().mainItems; track group.label) {

            <div class="flex flex-col">
              <ul class="list-none m-0 overflow-hidden flex flex-col gap-0">

                @for (item of group.children; track item.label) {
                  <li>
                    @if (item.section) {
                      <div class="text-[9px] uppercase tracking-[0.15em] text-surface-400 mt-[18px] mb-2 px-[10px] whitespace-nowrap">
                        {{ item.section }}
                      </div>
                    }
                    <a
                      #rla="routerLinkActive"
                      [routerLink]="item.link"
                      routerLinkActive
                      [routerLinkActiveOptions]="{ exact: false }"
                      [ngClass]="{
    'bg-surface-900 text-surface-50 border-0!': rla.isActive
}"
                      class="active-class flex items-center cursor-pointer p-[10px] gap-3 rounded-[7px]
         text-surface-300
         transition-colors duration-150
         group
         border-0
         hover:bg-surface-900
         hover:text-surface-50
         ">
                      <i
                        [class]="item.icon + ' text-surface-300 group-hover:text-surface-50'"
                        [ngClass]="{
    'text-surface-50': rla.isActive
  }"
                      ></i>

                      <span class="font-normal text-[13px] leading-tight whitespace-nowrap group-hover:text-surface-50">{{ item.label }}</span>
                    </a>
                  </li>
                }

              </ul>

            </div>

          }
        </li>
      </ul>
    </div>

    <div class="-mx-[14px] -mb-[22px] mt-auto border-surface-800 border-t">
      <ul class="list-none p-2 m-0 hidden animate-duration-150 overflow-hidden">
        <li>
          <a
            class="flex items-center cursor-pointer p-3 gap-2 rounded-lg text-surface-300 hover:bg-surface-900 border border-transparent hover:border-surface-800 transition-colors duration-150 hover:text-surface-50"
          >
            <i class="pi pi-user text-base! leading-none!"></i>
            <span class="font-medium text-base leading-tight">Profile</span>
          </a>
        </li>
        <li>
          <a
            class="flex items-center cursor-pointer p-3 gap-2 rounded-lg text-surface-300 hover:bg-surface-900 border border-transparent hover:border-surface-800 transition-colors duration-150 hover:text-surface-50"
          >
            <i class="pi pi-cog text-base! leading-none!"></i>
            <span class="font-medium text-base leading-tight">Settings</span>
          </a>
        </li>
        <li>
          <a
            (click)="logout()"
            class="flex items-center cursor-pointer p-3 gap-2 rounded-lg text-surface-300 hover:bg-surface-900 border border-transparent hover:border-surface-800 transition-colors duration-150 hover:text-surface-50"
          >
            <i class="pi pi-sign-out text-base! leading-none!"></i>
            <span class="font-medium text-base leading-tight">Sign Out</span>
          </a>
        </li>
      </ul>
      <a
        pStyleClass="@prev"
        enterFromClass="hidden"
        enterActiveClass="animate-slidedown"
        leaveToClass="hidden"
        leaveActiveClass="animate-slideup"
        class="flex items-center cursor-pointer p-2 gap-2 text-surface-50 transition-colors duration-150"
      >
        @if (userProfile().picture) {
          <p-avatar
            [image]="userProfile().picture ?? ''"
            [ariaLabel]="userProfile().name"
            shape="circle"
            size="normal"
            class="w-8 h-8"
          ></p-avatar>
        } @else {
          <p-avatar
            [label]="userProfile().name.charAt(0).toUpperCase()"
            shape="circle"
            size="normal"
            class="w-8 h-8 bg-surface-500/20 text-surface-100"
          ></p-avatar>
        }
        <div class="flex flex-col overflow-hidden">
            <span class="font-medium text-base leading-tight truncate whitespace-nowrap">{{ userProfile().name }}</span>
          @if (userProfile().email) {
            <span class="text-xs text-surface-300 truncate whitespace-nowrap">{{ userProfile().email }}</span>
          }
        </div>
        <i class="pi pi-angle-up text-base! leading-none! text-surface-300 ml-auto"></i>
      </a>
    </div>
  </div>
</div>
